import { useEffect, ReactNode } from 'react'

interface HistoryPanelProps {
  title: string
  onClose: () => void
  children: ReactNode
}

export default function HistoryPanel({ title, onClose, children }: HistoryPanelProps) {
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose()
    }
    document.addEventListener('keydown', handleKeyDown)
    return () => document.removeEventListener('keydown', handleKeyDown)
  }, [onClose])

  return (
    <>
      <div
        className="fixed inset-0 z-30 bg-black/40 backdrop-blur-[2px]"
        onClick={onClose}
      />
      <div
        className="fixed inset-y-0 right-0 z-40 w-[480px] max-w-[85vw] bg-linear-bg-sidebar border-l border-linear-border shadow-2xl flex flex-col animate-slide-in-right"
        role="dialog"
        aria-modal="true"
        aria-label={title}
      >
        <div className="flex items-center justify-between px-4 py-3 border-b border-linear-border">
          <h2 className="text-sm font-semibold text-linear-text truncate">{title}</h2>
          <button
            onClick={onClose}
            className="flex-shrink-0 p-1 rounded text-linear-text-muted hover:text-linear-text hover:bg-linear-bg-hover transition-colors ml-2"
            aria-label="Close history panel"
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        <div className="flex-1 overflow-y-auto">
          {children}
        </div>
      </div>
    </>
  )
}
